import { jsx as h, jsxs as Z, Fragment as Ue } from "react/jsx-runtime";
import { QUERIES as Ce, BREAKPOINTS as Ze } from "@fcamna/shared-component-foundations";
import Y, { createContext as ke, useState as be, useCallback as Ke, useContext as ge, useRef as fe, useEffect as te, useMemo as qe } from "react";
import { u as Ge } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Disclosures as Pe } from "./disclosure.js";
import Q, { css as $e } from "styled-components";
import { u as re } from "./uniqueId-321287e8.mjs";
import { Checkbox as pe, CheckboxStateValues as ce } from "./checkbox.js";
import { TableContext as he } from "./table.js";
import { fordProIcons as Ae } from "@fcamna/shared-icons";
import { u as se } from "./useAccessibilityProps-2f24cf29.mjs";
import { c as Te } from "./index-65016bfa.mjs";
import { AccordionPanel as et } from "./accordion.js";
import "./setup-0f23222d.mjs";
import { T as X, a as tt, b as nt } from "./tableContainer-b8b41f9e.mjs";
import { Button as ct } from "./button.js";
import { StyledTableFilterGroup as ot, Filter as at } from "./filter.js";
import { Pagination as lt } from "./pagination.js";
import { TextInput as it } from "./textInput.js";
import { u as dt } from "./useWindowDimensions-ae69e913.mjs";
const me = (e) => !!new RegExp(
  new RegExp("(?<!\\S)(?:[$€£¥₹₽₩₪₫฿₴₱₲₵₣₺₼₦₡₭₸د.إر.س﷼د.بد.كد.عر.ع৳₮৲₠₤ƒ]|\\d+[\\.,]?\\d*)\\s?\\d{1,3}(?:[.,\\s]\\d{3})*(?:[.,]\\d{2})?(?!\\S)", "g")
).test(e), ue = (e) => parseFloat(e.replace(/[^0-9.-]+/g, "")), mt = (e, o = 300) => {
  let t;
  return function(...u) {
    clearTimeout(t), t = setTimeout(() => e.apply(this, u), o);
  };
}, Qe = ke({}), rt = ({ children: e, boxVariation: o }) => {
  const [t, u] = be(null), C = Ke((a) => {
    u((n) => n === a ? null : a);
  }, []), $ = {
    openItemId: t,
    handleItemClick: C,
    isParentBoxVariation: o
  };
  return /* @__PURE__ */ h(Qe.Provider, { value: $, children: e });
}, ut = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x;
  return `
    width: ${(C = (u = (t = (o = e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.AccordionContainer) == null ? void 0 : C.width};
    display: ${(l = (n = (a = ($ = e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.AccordionContainer) == null ? void 0 : l.display};
    flex-direction: ${(W = (m = (g = (f = e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.AccordionContainer) == null ? void 0 : W.flexDirection};
    gap: ${e.boxVariation ? (V = (D = (w = (i = e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.AccordionContainer) == null ? void 0 : V.gap.boxVariation : (x = (L = (E = (T = e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.AccordionContainer) == null ? void 0 : x.gap.default};
  `;
}}
`, bt = "ACCORDION_DATA_TEST_ID", ht = ({
  children: e = [],
  boxVariation: o = !1,
  singleSelect: t,
  className: u,
  containerId: C,
  dataTestId: $ = bt
}) => {
  const a = Array.isArray(e) ? e : [e], n = Ge({ label: "Accordion" });
  return /* @__PURE__ */ h(rt, { boxVariation: o, children: /* @__PURE__ */ h(
    ut,
    {
      id: C,
      dataTestId: $,
      className: u,
      singleSelect: t,
      boxVariation: o,
      ...n,
      children: a.map((l, f) => l ? Y.cloneElement(l, {
        singleSelect: t,
        id: l.props.id,
        title: l.props.title,
        subTitle: l.props.subTitle,
        icon: l.props.icon,
        boxVariation: l.props.boxVariation,
        className: l.props.className,
        dataTestId: l.props.dataTestId,
        children: l.props.children,
        disabled: l.props.disabled,
        key: f
      }) : null)
    }
  ) });
}, { CaretUp: ft } = Ae, st = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H, A, b, d, v, I, s, M, R, U, O, K, F, z, j, _, P, c, r, B, q, J, G, k, ne, p, ee, ae, le, ie, de, Ie, ve, we, Ee, ye, We, xe, De, Se, Le, Ve, Ne, He, Fe, Re, _e, Be, Me;
  return `
    display: ${(C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.AccordionItemWrapper) == null ? void 0 : C.display};
    flex-direction: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.AccordionItemWrapper) == null ? void 0 : l.flexDirection};
    border-bottom: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.AccordionItemWrapper) == null ? void 0 : W.borderBottom};
    background: ${e.disabled && e.boxVariation ? (V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.AccordionItemWrapper) == null ? void 0 : V.background.boxVariationDisabled : (x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.AccordionItemWrapper) == null ? void 0 : x.background.default};

    &:hover {
      border-bottom: ${e.disabled ? (H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.AccordionItemWrapper) == null ? void 0 : H.hover.borderBottomDisabled : (v = (d = (b = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : b.accordion) == null ? void 0 : d.AccordionItemWrapper) == null ? void 0 : v.hover.borderBottomDefault};
    }
    &:focus-visible {
      outline: ${(R = (M = (s = (I = e == null ? void 0 : e.theme) == null ? void 0 : I.components) == null ? void 0 : s.accordion) == null ? void 0 : M.AccordionItemWrapper) == null ? void 0 : R.focusVisible.outline};
      border-bottom: ${(F = (K = (O = (U = e == null ? void 0 : e.theme) == null ? void 0 : U.components) == null ? void 0 : O.accordion) == null ? void 0 : K.AccordionItemWrapper) == null ? void 0 : F.focusVisible.borderBottom};
    }

    ${e.boxVariation && `
        border-radius: ${(P = (_ = (j = (z = e == null ? void 0 : e.theme) == null ? void 0 : z.components) == null ? void 0 : j.accordion) == null ? void 0 : _.AccordionItemWrapper) == null ? void 0 : P.boxVariation.borderRadius};
        outline: ${(q = (B = (r = (c = e == null ? void 0 : e.theme) == null ? void 0 : c.components) == null ? void 0 : r.accordion) == null ? void 0 : B.AccordionItemWrapper) == null ? void 0 : q.boxVariation.outline};
        border-bottom:${(ne = (k = (G = (J = e == null ? void 0 : e.theme) == null ? void 0 : J.components) == null ? void 0 : G.accordion) == null ? void 0 : k.AccordionItemWrapper) == null ? void 0 : ne.boxVariation.borderBottom};

        &:hover {
          outline: 
          ${e.disabled ? (de = (ie = (le = (ae = (ee = (p = e == null ? void 0 : e.theme) == null ? void 0 : p.components) == null ? void 0 : ee.accordion) == null ? void 0 : ae.AccordionItemWrapper) == null ? void 0 : le.boxVariation) == null ? void 0 : ie.hover) == null ? void 0 : de.outlineDisabled : (We = (ye = (Ee = (we = (ve = (Ie = e == null ? void 0 : e.theme) == null ? void 0 : Ie.components) == null ? void 0 : ve.accordion) == null ? void 0 : we.AccordionItemWrapper) == null ? void 0 : Ee.boxVariation) == null ? void 0 : ye.hover) == null ? void 0 : We.outlineDefault};
          border-bottom:${(Le = (Se = (De = (xe = e == null ? void 0 : e.theme) == null ? void 0 : xe.components) == null ? void 0 : De.accordion) == null ? void 0 : Se.AccordionItemWrapper) == null ? void 0 : Le.boxVariation.hover.borderBottom}
        }
        &:focus-visible {
          outline:  ${(Fe = (He = (Ne = (Ve = e == null ? void 0 : e.theme) == null ? void 0 : Ve.components) == null ? void 0 : Ne.accordion) == null ? void 0 : He.AccordionItemWrapper) == null ? void 0 : Fe.boxVariation.focusVisible.outline};
          border-bottom:${(Me = (Be = (_e = (Re = e == null ? void 0 : e.theme) == null ? void 0 : Re.components) == null ? void 0 : _e.accordion) == null ? void 0 : Be.AccordionItemWrapper) == null ? void 0 : Me.boxVariation.focusVisible.borderBottom};
  `}
  `;
}}
`, Tt = Q.button`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H, A, b, d, v, I, s, M, R, U, O, K, F, z, j, _, P, c, r, B, q, J, G, k, ne;
  return `
    display: ${(C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.HeaderWrapper) == null ? void 0 : C.display};
    padding: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.HeaderWrapper) == null ? void 0 : l.padding};
    flex-direction: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.HeaderWrapper) == null ? void 0 : W.flexDirection};
    align-items: ${e.$isDropDownMenu ? (V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.HeaderWrapper) == null ? void 0 : V.alignItems.isDropDownMenu : (x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.HeaderWrapper) == null ? void 0 : x.alignItems.default};
    gap: ${(H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.HeaderWrapper) == null ? void 0 : H.gap};
    align-self: ${(v = (d = (b = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : b.accordion) == null ? void 0 : d.HeaderWrapper) == null ? void 0 : v.alignSelf};
    cursor: ${e.disabled ? (R = (M = (s = (I = e == null ? void 0 : e.theme) == null ? void 0 : I.components) == null ? void 0 : s.accordion) == null ? void 0 : M.HeaderWrapper) == null ? void 0 : R.cursor.disabled : (F = (K = (O = (U = e == null ? void 0 : e.theme) == null ? void 0 : U.components) == null ? void 0 : O.accordion) == null ? void 0 : K.HeaderWrapper) == null ? void 0 : F.cursor.default};

    background: ${e.disabled && e.boxVariation ? (P = (_ = (j = (z = e == null ? void 0 : e.theme) == null ? void 0 : z.components) == null ? void 0 : j.accordion) == null ? void 0 : _.HeaderWrapper) == null ? void 0 : P.background.boxVariationDisabled : (q = (B = (r = (c = e == null ? void 0 : e.theme) == null ? void 0 : c.components) == null ? void 0 : r.accordion) == null ? void 0 : B.HeaderWrapper) == null ? void 0 : q.background.default};
    border: ${(ne = (k = (G = (J = e == null ? void 0 : e.theme) == null ? void 0 : J.components) == null ? void 0 : G.accordion) == null ? void 0 : k.HeaderWrapper) == null ? void 0 : ne.border};
  `;
}}
`, Ct = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x;
  return `
    display: ${(C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.HeaderContentWrapper) == null ? void 0 : C.display};
    flex-direction: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.HeaderContentWrapper) == null ? void 0 : l.flexDirection};
    align-items: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.HeaderContentWrapper) == null ? void 0 : W.alignItems};
    gap: ${(V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.HeaderContentWrapper) == null ? void 0 : V.gap};
    flex: ${(x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.HeaderContentWrapper) == null ? void 0 : x.flex};
  `;
}}
`, gt = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H, A, b, d, v;
  return `
    color: ${e.disabled ? (C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.TitleWrapper) == null ? void 0 : C.color.disabled : (l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.TitleWrapper) == null ? void 0 : l.color.default};

    font-family: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.TitleWrapper) == null ? void 0 : W.fontFamily};
    font-size: ${(V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.TitleWrapper) == null ? void 0 : V.fontSize};
    font-style: ${(x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.TitleWrapper) == null ? void 0 : x.fontStyle};
    font-weight: ${(H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.TitleWrapper) == null ? void 0 : H.fontWeight};
    line-height: ${(v = (d = (b = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : b.accordion) == null ? void 0 : d.TitleWrapper) == null ? void 0 : v.lineHeight};
  `;
}}
`, $t = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H, A, b, d, v;
  return `
    color: ${e.disabled ? (C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.SubtitleWrapper) == null ? void 0 : C.color.disabled : (l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.SubtitleWrapper) == null ? void 0 : l.color.default};
    font-family: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.SubtitleWrapper) == null ? void 0 : W.fontFamily};
    font-size: ${(V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.SubtitleWrapper) == null ? void 0 : V.fontSize};
    font-style: ${(x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.SubtitleWrapper) == null ? void 0 : x.fontStyle};
    font-weight: ${(H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.SubtitleWrapper) == null ? void 0 : H.fontWeight};
    line-height: ${(v = (d = (b = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : b.accordion) == null ? void 0 : d.SubtitleWrapper) == null ? void 0 : v.lineHeight};
  `;
}}
`, At = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H, A, b, d, v, I, s, M, R;
  return `
    display: ${(C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.LeadingIconWrapper) == null ? void 0 : C.display};
    min-height: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.LeadingIconWrapper) == null ? void 0 : l.minHeight};
    justify-content: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.LeadingIconWrapper) == null ? void 0 : W.justifyContent};
    align-items: ${(V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.LeadingIconWrapper) == null ? void 0 : V.alignItems};

    svg,
    img {
      width: ${(x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.LeadingIconWrapper) == null ? void 0 : x.svg.width};
      height: ${(H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.LeadingIconWrapper) == null ? void 0 : H.svg.height};
      color: ${e.disabled ? (v = (d = (b = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : b.accordion) == null ? void 0 : d.LeadingIconWrapper) == null ? void 0 : v.svg.color.disabled : (R = (M = (s = (I = e == null ? void 0 : e.theme) == null ? void 0 : I.components) == null ? void 0 : s.accordion) == null ? void 0 : M.LeadingIconWrapper) == null ? void 0 : R.svg.color.default};
    }
  `;
}}
`, It = Q.span`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H, A, b, d, v;
  return `
    display: ${(C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.ToggleIconWrapper) == null ? void 0 : C.display};
    width: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.ToggleIconWrapper) == null ? void 0 : l.width};
    height: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.ToggleIconWrapper) == null ? void 0 : W.height};
    justify-content: ${(V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.ToggleIconWrapper) == null ? void 0 : V.justifyContent};
    align-items: ${(x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.ToggleIconWrapper) == null ? void 0 : x.alignItems};
    transform: rotate(${e.isAccordionOpen ? "0deg" : "-180deg"});
    transition: transform ${e.$isAnimate ? "0.3s" : "0s"} ease-in-out;

    svg,
    img {
      color: ${e.disabled ? (H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.ToggleIconWrapper) == null ? void 0 : H.svg.color.disabled : (v = (d = (b = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : b.accordion) == null ? void 0 : d.ToggleIconWrapper) == null ? void 0 : v.svg.color.default};
    }
  `;
}}
`, vt = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H;
  return `
    ${e.$isAnimate ? `
        height: ${e.accordionOpen ? `${e.$wrapperHeight}px` : (C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.ContentWrapper) == null ? void 0 : C.animate.defaultHeight};
        overflow: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.ContentWrapper) == null ? void 0 : l.animate.overflow};
        transition: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.ContentWrapper) == null ? void 0 : W.animate.transition};
      ` : `
        display: ${e.accordionOpen ? (V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.ContentWrapper) == null ? void 0 : V.display.accordionOpen : (x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.ContentWrapper) == null ? void 0 : x.display.default};
      `}
    padding: ${(H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.ContentWrapper) == null ? void 0 : H.padding}
  `;
}}
`, wt = Q.div`
  ${(e) => {
  var o, t, u, C, $, a, n, l, f, g, m, W, i, w, D, V, T, E, L, x, S, y, N, H;
  return `
    display: ${(C = (u = (t = (o = e == null ? void 0 : e.theme) == null ? void 0 : o.components) == null ? void 0 : t.accordion) == null ? void 0 : u.AccordionItemEnd) == null ? void 0 : C.display};
    flex-direction: ${(l = (n = (a = ($ = e == null ? void 0 : e.theme) == null ? void 0 : $.components) == null ? void 0 : a.accordion) == null ? void 0 : n.AccordionItemEnd) == null ? void 0 : l.flexDirection};
    justify-content: ${(W = (m = (g = (f = e == null ? void 0 : e.theme) == null ? void 0 : f.components) == null ? void 0 : g.accordion) == null ? void 0 : m.AccordionItemEnd) == null ? void 0 : W.justifyContent};
    align-items: ${e.$isDropDownMenu ? (V = (D = (w = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : w.accordion) == null ? void 0 : D.AccordionItemEnd) == null ? void 0 : V.alignItems.dropdownMenu : (x = (L = (E = (T = e == null ? void 0 : e.theme) == null ? void 0 : T.components) == null ? void 0 : E.accordion) == null ? void 0 : L.AccordionItemEnd) == null ? void 0 : x.alignItems.default};
    gap: ${(H = (N = (y = (S = e == null ? void 0 : e.theme) == null ? void 0 : S.components) == null ? void 0 : y.accordion) == null ? void 0 : N.AccordionItemEnd) == null ? void 0 : H.gap};
  `;
}}
`, Et = "ACCORDION_ITEM_DATA_TEST_ID", yt = ({
  children: e,
  title: o,
  subTitle: t,
  singleSelect: u,
  id: C,
  icon: $,
  boxVariation: a,
  disabled: n,
  className: l,
  dataTestId: f = Et,
  isIconOnClickEnabled: g = !0,
  isDropDownMenu: m = !1,
  DropDownComponent: W,
  isAnimate: i = !0,
  accessibilityOptions: w = {}
}) => {
  var d;
  const { openItemId: D, handleItemClick: V } = ge(Qe), T = D === C, [E, L] = be(!1), x = fe(null), S = se("button", {
    ...w,
    ariaExpanded: E,
    ariaControls: `accordion-content-${C}`,
    ariaDisabled: n || !1,
    tabIndex: -1
  }), y = se("region", {
    ariaLabelledBy: `accordion-header-${C}`,
    ariaHidden: u ? !T : !E
  });
  te(() => {
    x.current && E && i && (x.current.style.maxHeight = `${x.current.scrollHeight}px`);
  }, [E, i]);
  const N = () => {
    E ? A() : H(), u && V(C);
  }, H = () => {
    L(!0);
  }, A = Y.useCallback(() => {
    L(!1);
  }, []);
  return /* @__PURE__ */ Z(
    st,
    {
      tabIndex: n ? -1 : 0,
      onKeyDown: (v) => {
        (v.key === "Enter" || v.key === " ") && (v.preventDefault(), N());
      },
      accordionOpen: E,
      disabled: n,
      boxVariation: a,
      children: [
        /* @__PURE__ */ Z(
          Tt,
          {
            id: `accordion-header-${C}`,
            "data-testid": f,
            boxVariation: a,
            disabled: n,
            singleSelect: u,
            className: l,
            onClick: !n && !Y.isValidElement(W) ? N : void 0,
            accordionOpen: E,
            $isDropDownMenu: m,
            ...S,
            children: [
              $ && /* @__PURE__ */ h(
                At,
                {
                  "data-component": "accordion-icon-wrapper",
                  disabled: n,
                  onClick: (v) => {
                    g && N(), v.stopPropagation();
                  },
                  children: $
                }
              ),
              /* @__PURE__ */ Z(
                Ct,
                {
                  onClick: () => {
                    N();
                  },
                  children: [
                    /* @__PURE__ */ h(
                      gt,
                      {
                        disabled: n,
                        "data-component": "accordion-title-wrapper",
                        children: o
                      }
                    ),
                    t && /* @__PURE__ */ h($t, { disabled: n, children: t })
                  ]
                }
              ),
              /* @__PURE__ */ Z(wt, { $isDropDownMenu: m, children: [
                /* @__PURE__ */ h(
                  It,
                  {
                    onClick: () => {
                      N();
                    },
                    "data-component": "accordion-dropdown-wrapper",
                    icon: $,
                    disabled: n,
                    role: "button",
                    isAccordionOpen: u ? T : E,
                    $isAnimate: i,
                    children: /* @__PURE__ */ h(ft, { "aria-hidden": !1 })
                  }
                ),
                m && W || null
              ] })
            ]
          }
        ),
        /* @__PURE__ */ h(
          vt,
          {
            accordionOpen: u ? T : E,
            isSingleSelectOpen: T,
            "aria-labelledby": `accordion-header-${C}`,
            id: `accordion-content-${C}`,
            "aria-hidden": u ? !T : !E,
            ref: x,
            $wrapperHeight: (d = x == null ? void 0 : x.current) == null ? void 0 : d.scrollHeight,
            $isAnimate: i,
            role: "region",
            ...y,
            children: e
          }
        )
      ]
    }
  );
}, Wt = Q.div`
  &.AccordionPanel {
    ${({
  theme: {
    components: { accordionV1: e }
  }
}) => $e(e.AccordionPanel)};
  }
`, Tn = ({
  content: e,
  children: o,
  className: t,
  dataTestId: u = "ACCORDION_PANEL_DATA_TEST_ID"
}) => /* @__PURE__ */ h(
  Wt,
  {
    className: Te(["AccordionPanel", t]),
    "data-testid": u,
    children: o || e
  }
), xt = Q(ht)`
  ${(e) => `
 border-radius: ${e.theme.components.dataTable.TableAccordionData.borderRadius};
 && > div {
    align-items: ${e.theme.components.dataTable.TableAccordionData.div.alignItems};
    width: ${e.theme.components.dataTable.TableAccordionData.div.width};
    border-top: ${e.theme.components.dataTable.TableAccordionData.div.borderTop};
    border-bottom: ${e.theme.components.dataTable.TableAccordionData.div.borderBottom};
    border-radius: ${e.theme.components.dataTable.TableAccordionData.div.borderRadius};
 }
  @media ${Ce.tabletAndUp} {
    display: ${e.theme.components.dataTable.TableAccordionData.div.tabletView.display};
  }
  border-top: ${e.theme.components.dataTable.TableAccordionData.borderTop};
  border-bottom: ${e.theme.components.dataTable.TableAccordionData.borderBottom};
    `}
`, Dt = Q(yt)`
  ${(e) => `
    && span.CheckBox__checkmark-container {
      left: ${e.theme.components.dataTable.TableAccordionItemData.checkBoxSpan.left};
      top: ${e.theme.components.dataTable.TableAccordionItemData.checkBoxSpan.top};
    }
    background: ${e.$background ? e.theme.components.dataTable.TableAccordionItemData.backgroundColor.isBackground : e.theme.components.dataTable.TableAccordionItemData.backgroundColor.none};
    border-radius: ${e.theme.components.dataTable.TableAccordionItemData.borderRadius};
    padding: ${e.theme.components.dataTable.TableAccordionItemData.padding};
    && > div {
      padding-left: ${e.theme.components.dataTable.TableAccordionItemData["&& > div"].paddingLeft};
    }
    [data-component='accordion-dropdown-wrapper'] {
      color: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-dropdown-wrapper"]'].color};
    }
    [data-component='accordion-title-wrapper'] {
      height: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].height};
      font-family: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontFamily};
      font-size: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontSize};
      font-style: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontStyle};
      font-weight: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontWeight};
      line-height: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].lineHeight};
    }
    ${e.$showcheckboxenabled ? `[data-component="accordion-icon-wrapper"]{

          }
        ` : ""}
    `}
`, St = Q.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.display};;
    flex-direction: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.flexDirection};
    align-items: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.alignItems};
    gap: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.gap};
    align-self: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.alignSelf};
    `}
`, Oe = Q.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.display};
    flex-direction: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.flexDirection};
    align-items: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.alignItems};
    gap: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.gap};
   && > div {
      gap: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.div.gap};
      align-items: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.div.alignItems};
    }
    align-self: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.alignSelf};
    `}
`, Lt = Q(et)`
  ${(e) => `
    width: ${e.theme.components.dataTable.TableAccordionPanelData.width};
    height: ${e.theme.components.dataTable.TableAccordionPanelData.height};
    justify-content: ${e.theme.components.dataTable.TableAccordionPanelData.justifyContent};
    margin: ${e.theme.components.dataTable.TableAccordionPanelData.margin};
    padding: ${e.theme.components.dataTable.TableAccordionPanelData.padding};
    && > div {
      color: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].color};
      font-family: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].fontFamily};
      font-size: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].fontSize};
      letter-spacing: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].letterSpacing};
      line-height: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].lineHeight};
    }
    `}
`, Vt = ({ content: e, title: o, rowElementIndex: t, id: u, backgroundColor: C, DropDownComponent: $, $checkboxProps: a }) => {
  const { checkboxCheckedValues: n, setCheckboxChecked: l, showOptionsEnabled: f, showCheckboxEnabled: g } = Y.useContext(he), m = n == null ? void 0 : n.find((W) => W.id === u);
  return /* @__PURE__ */ h(xt, { "data-component": "accordion-data", children: /* @__PURE__ */ h(
    Dt,
    {
      title: o,
      id: `${t}`,
      $showcheckboxenabled: g,
      $background: C,
      isIconOnClickEnabled: !1,
      isDropDownMenu: f,
      DropDownComponent: $,
      isAnimate: !1,
      icon: g && /* @__PURE__ */ h(
        pe,
        {
          checkboxValue: (a == null ? void 0 : a.value) || (m == null ? void 0 : m.value),
          onChange: (W) => {
            l && l(
              u,
              ((m == null ? void 0 : m.value) === ce.UNCHECKED || (m == null ? void 0 : m.value) === void 0) && ce.CHECKED || ce.UNCHECKED
            ), a && a.onClick && a.onClick(
              W,
              u,
              ((m == null ? void 0 : m.value) === ce.UNCHECKED || (m == null ? void 0 : m.value) === void 0) && ce.CHECKED || ce.UNCHECKED
            );
          },
          isDisabled: (a == null ? void 0 : a.disabled) || (m == null ? void 0 : m.disabled)
        }
      ) || "",
      children: /* @__PURE__ */ h(
        Lt,
        {
          content: /* @__PURE__ */ h(St, { children: e })
        }
      )
    }
  ) });
}, { ArrowDown: Nt, ArrowUp: Ht, Sorting: Ft } = Ae, Rt = Q.button`
  ${(e) => `
    border-color: ${e.theme.components.dataTable.TableSortingView.Wrapper.borderColor};
    background-color: ${e.theme.components.dataTable.TableSortingView.Wrapper.backgroundColor};
    color: ${e.theme.components.dataTable.TableSortingView.Wrapper.color};
    `}
`, Je = ({
  rowValues: e,
  setRowValues: o,
  columnNumber: t,
  onClick: u,
  setSortingEnabled: C,
  columnName: $,
  accessibilityOptions: a
}) => {
  const { sortOrder: n, setSortOrder: l } = ge(he);
  te(() => {
    C(!0);
  }, []);
  const f = () => {
    const m = {
      columnNumber: t,
      value: (n == null ? void 0 : n.value) === "asc" ? "desc" : "asc"
    };
    l(m), o(e, m);
  }, g = se("button", {
    ariaLabel: n.columnNumber === t && (n == null ? void 0 : n.value) === "asc" && `Sort column ${$} in ascending order` || n.columnNumber === t && (n == null ? void 0 : n.value) === "desc" && `Sort column ${$} in descending order` || `Sort column ${$} in default order`,
    ...a
  });
  return /* @__PURE__ */ h(
    Rt,
    {
      onClick: (m) => {
        m.preventDefault(), f(), u && u(m, (n == null ? void 0 : n.value) === "asc" ? "desc" : "asc");
      },
      ...g,
      children: n.columnNumber === t && (n == null ? void 0 : n.value) === "asc" && /* @__PURE__ */ h(Ht, { size: "s" }) || n.columnNumber === t && (n == null ? void 0 : n.value) === "desc" && /* @__PURE__ */ h(Nt, { size: "s" }) || /* @__PURE__ */ h(Ft, { size: "s" })
    }
  );
}, ze = Q.div`
  ${(e) => `
    color: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.color};
    font-family: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontFamily};
    font-size: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontSize};
    font-style: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontStyle};
    font-weight: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontWeight};
    line-height: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.lineHeight};

    `}
`, je = Q.div`
  ${(e) => `
    && > :not(button) {
      color: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.color};
      font-family: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontFamily};
      font-size: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontSize};
      font-style: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontStyle};
      font-weight: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontWeight};
      line-height: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.lineHeight};
    }
    `}
`, _t = Q.div`
  &.TableEmptyView-wrapper {
    ${({
  theme: {
    components: { dataTable: e }
  }
}) => $e(e.TableEmptyViewWrapper)};
  }
`, Bt = Q.div`
  &.TableEmptyViewContainer-container {
    ${({
  theme: {
    components: { dataTable: e }
  }
}) => $e(e.TableEmptyViewContainer)};
  }
`, Xe = ({
  children: e,
  isMarketingTable: o = !1,
  isMobile: t
}) => /* @__PURE__ */ h(Bt, { className: Te(["TableEmptyViewContainer-container"]), children: /* @__PURE__ */ h(
  _t,
  {
    className: Te([
      "TableEmptyView-wrapper",
      { "TableEmptyView-wrapper--marketingTable": o },
      { "TableEmptyView-wrapper--mobile": t }
    ]),
    children: e
  }
) }), oe = Q.div`
  display: flex;
  align-items: center;

  @media ${Ce.tabletAndUp} {
    margin: auto 0;
    && > div {
      align-items: center;
    }
  }
`, Ye = Q.div`
  @media ${Ce.tabletAndUp} {
    display: flex;
    flex-direction: column;
  }
`, Mt = ({
  headerValues: e,
  rowValues: o = [],
  headerCheckboxProps: t,
  setRowValues: u,
  emptyTableMessage: C,
  setSortingEnabled: $
}) => {
  var f, g, m, W, i, w, D, V, T, E, L, x;
  const a = e.map((S, y) => /* @__PURE__ */ Z(X.CellContent, { children: [
    S.leadingComponents,
    S.textValue && /* @__PURE__ */ h(X.CellContentText, { contentAlignment: S.contentAlignment, children: S.textValue }),
    S.trailingComponents
  ] }, y)), n = /* @__PURE__ */ h(
    tt,
    {
      $checkboxProps: t,
      children: /* @__PURE__ */ Z(
        X.Header,
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
          },
          children: [
            /* @__PURE__ */ Z(X.CellContent, { children: [
              (f = e[0]) == null ? void 0 : f.leadingComponents,
              ((g = e[0]) == null ? void 0 : g.textValue) && /* @__PURE__ */ h(X.CellContentText, { contentAlignment: (m = e[0]) == null ? void 0 : m.contentAlignment, children: (W = e[0]) == null ? void 0 : W.textValue }),
              (i = e[0]) == null ? void 0 : i.trailingComponents
            ] }),
            (((w = e[0]) == null ? void 0 : w.isSortingEnabled) || ((V = (D = e[0]) == null ? void 0 : D.sortingProp) == null ? void 0 : V.isSortingEnabled)) && /* @__PURE__ */ h(
              Je,
              {
                setSortingEnabled: $,
                rowValues: o,
                setRowValues: (...S) => {
                  var y, N;
                  return u(...S, (N = (y = e[0]) == null ? void 0 : y.sortingProp) == null ? void 0 : N.comparator);
                },
                columnNumber: 0,
                columnName: ((T = e[0]) == null ? void 0 : T.textValue) || ((E = e[0]) == null ? void 0 : E.columnAlternateText) || "",
                onClick: (x = (L = e[0]) == null ? void 0 : L.sortingProp) == null ? void 0 : x.onClick
              }
            )
          ]
        }
      )
    },
    re("thead")
  ), l = [];
  return l.push(n), o.length > 0 ? o.forEach((S, y) => {
    let N, H;
    S.cellData.forEach((A, b) => {
      const d = /* @__PURE__ */ Z(
        X.Cell,
        {
          $contentAlignment: e[b].contentAlignment || "center",
          id: A.id,
          children: [
            A.leadingComponents && /* @__PURE__ */ h(oe, { children: A.leadingComponents }),
            /* @__PURE__ */ Z(Ye, { children: [
              /* @__PURE__ */ Z(X.CellContent, { children: [
                A.textValue && /* @__PURE__ */ h(X.CellContentText, { contentAlignment: e[b].contentAlignment || "center", children: A.textValue }),
                A.trailingComponents && !A.textValue && /* @__PURE__ */ h(oe, { children: A.trailingComponents })
              ] }),
              A.description && /* @__PURE__ */ h(X.CellDescription, { children: A.description }),
              (A == null ? void 0 : A.secondaryDescription) && /* @__PURE__ */ h(X.CellDescription, { children: A == null ? void 0 : A.secondaryDescription })
            ] }),
            A.trailingComponents && A.textValue && /* @__PURE__ */ h(oe, { children: A.trailingComponents })
          ]
        },
        `${A.id || b}_0_${re("table_cell")}`
      );
      b === 0 ? N = d : Y.isValidElement(H) ? H = /* @__PURE__ */ Z(Ue, { children: [
        H,
        /* @__PURE__ */ Z(Oe, { children: [
          /* @__PURE__ */ h(ze, { className: "label", children: a[b] }),
          /* @__PURE__ */ h(je, { children: d })
        ] }, `${A.id || b}_0_${re("table_cell")}`)
      ] }) : H = /* @__PURE__ */ Z(Oe, { children: [
        /* @__PURE__ */ h(ze, { className: "label", children: a[b] }),
        /* @__PURE__ */ h(je, { children: d })
      ] }, `${A.id || b}_0_${re("table_cell")}`);
    }), l.push(
      /* @__PURE__ */ h(
        Vt,
        {
          content: H,
          title: N,
          rowElementIndex: y,
          id: S.rowId,
          $checkboxProps: S.checkboxProps,
          DropDownComponent: S.DropDownComponent
        }
      )
    );
  }) : l.push(/* @__PURE__ */ h(Xe, { isMobile: !0, children: C || "" })), l;
}, Ot = Q.span`
  display: flex;
  align-items: center;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`, zt = ({
  headerValues: e,
  rowValues: o,
  setRowValues: t,
  onClearAll: u,
  filterGroupLabel: C = "Filter by: ",
  clearAllLabel: $ = "Clear all",
  setFilterEnabled: a,
  variant: n = "individual",
  sortFilterValues: l = "desc",
  exceedOverflow: f = !1
}) => {
  const g = fe({}), [m, W] = be(!1), i = fe({}), { setAllCheckboxChecked: w } = ge(he), D = Ke((b, d) => {
    !i.current[b] && n === "progressive" && (i.current = {
      ...i.current,
      [b]: { value: [d], selectedLevel: -1 }
    });
  }, []), V = (b, d) => {
    const v = [], I = [], s = /* @__PURE__ */ new Set(), M = [];
    return e.forEach((R, U) => {
      o.forEach((O) => {
        var z;
        const K = ((z = O.cellData[U]) == null ? void 0 : z.id) ?? "";
        d.find((j) => j.includes(K)) && M.push(O.rowId);
      });
    }), e.forEach((R, U) => {
      o.forEach((O) => {
        var j, _, P;
        const K = ((j = R.filterProp) == null ? void 0 : j.label) || R.textValue || "", F = ((_ = O.cellData[U]) == null ? void 0 : _.textValue) || "", z = ((P = O.cellData[U]) == null ? void 0 : P.id) || "";
        if (M.includes(O.rowId) && K === b && !s.has(F))
          s.add(F), I.push({ label: F, value: z });
        else if (M.includes(O.rowId) && K === b && s.has(F)) {
          const c = I.find((r) => r.label === F);
          c ? c.value += `, ${z}` : I.push({ label: F, value: z });
        }
      });
    }), l === "asc" ? I.sort((R, U) => R.label.localeCompare(U.label)) : I.sort((R, U) => U.label.localeCompare(R.label)), v.push({ items: I }), v;
  }, T = (b, d) => {
    let v = 0;
    Object.keys(i.current).forEach((s) => {
      v <= i.current[s].selectedLevel && (v = i.current[s].selectedLevel);
    });
    let I = v;
    Object.keys(i.current).forEach((s) => {
      s === b && i.current[s].selectedLevel < 0 && (I = I + 1, i.current[s] = {
        ...i.current[s],
        selectedLevel: I
      });
    }), Object.keys(i.current).forEach((s) => {
      var M, R;
      if (s !== b && (i.current[s].selectedLevel >= I || i.current[s].selectedLevel < 0) && d.length) {
        const U = V(s, d);
        i.current[s] = {
          value: U,
          selectedLevel: i.current[s].selectedLevel
        };
      } else if (!d.length && s === b)
        delete i.current[s];
      else if (!d.length && s !== b && ((M = g.current[s]) != null && M.length)) {
        const U = V(s, g.current[s]);
        i.current[b] = {
          value: U,
          selectedLevel: ((R = i.current[b]) == null ? void 0 : R.selectedLevel) || -1
        };
        const O = e.findIndex((j) => j.textValue === s), K = [], F = [], z = /* @__PURE__ */ new Set();
        o.forEach((j) => {
          var c, r;
          const _ = ((c = j.cellData[O]) == null ? void 0 : c.textValue) || "", P = ((r = j.cellData[O]) == null ? void 0 : r.id) || "";
          if (_ && !z.has(_))
            z.add(_), F.push({ label: _, value: P });
          else if (_) {
            const B = F.find((q) => q.label === _);
            B ? B.value += `, ${P}` : F.push({ label: _, value: P });
          }
        }), l === "asc" ? F.sort((j, _) => j.label.localeCompare(_.label)) : F.sort((j, _) => _.label.localeCompare(j.label)), K.push({ items: F }), i.current[s] = {
          selectedLevel: i.current[s].selectedLevel,
          value: K
        };
      } else
        s !== b && (i.current[s].selectedLevel >= I || i.current[s].selectedLevel < 0) && !d.length && (i.current = {});
    });
  }, E = !!Object.keys(g.current).length, L = qe(() => !!E, [E]);
  te(() => {
    a(L);
  }, [L]), te(() => {
    W(e.some((b) => {
      var d;
      return (d = b.filterProp) == null ? void 0 : d.isFilterEnabled;
    }));
  }, [e]);
  const x = (b, d) => {
    var U, O, K, F, z;
    const v = [], I = [], s = /* @__PURE__ */ new Set();
    o.forEach((j) => {
      var c, r;
      const _ = ((c = j.cellData[b]) == null ? void 0 : c.textValue) || "", P = ((r = j.cellData[b]) == null ? void 0 : r.id) || "";
      if (_ && !s.has(_))
        s.add(_), I.push({ label: _, value: P });
      else if (_) {
        const B = I.find((q) => q.label === _);
        B ? B.value += `, ${P}` : I.push({ label: _, value: P });
      }
    }), l === "asc" ? I.sort((j, _) => j.label.localeCompare(_.label)) : I.sort((j, _) => _.label.localeCompare(j.label)), v.push({ items: I }), D(((U = d.filterProp) == null ? void 0 : U.label) || d.textValue || "", {
      items: I
    });
    const M = g.current[((O = d.filterProp) == null ? void 0 : O.label) || d.textValue || ""] || [];
    return { newFilterMenuList: ((K = d.filterProp) == null ? void 0 : K.menuOptions) || i.current[((F = d.filterProp) == null ? void 0 : F.label) || d.textValue || ""] && [
      ...i.current[((z = d.filterProp) == null ? void 0 : z.label) || d.textValue || ""].value
    ] || v, values: M };
  }, S = () => {
    const b = [];
    return e.forEach((d, v) => {
      var I, s, M;
      if ((I = d.filterProp) != null && I.isFilterEnabled) {
        const { newFilterMenuList: R, values: U } = x(v, d);
        b.push(
          /* @__PURE__ */ h(
            at,
            {
              exceedOverflow: f,
              menuDirection: (s = d.filterProp) == null ? void 0 : s.menuDirection,
              menuHeader: "local_search",
              menuLists: R,
              onChange: (O, K) => {
                var F, z;
                O.preventDefault(), O.stopPropagation(), H(O, K), (F = d.filterProp) != null && F.onClick && ((z = d.filterProp) == null || z.onClick(O, K));
              },
              value: U,
              children: ((M = d.filterProp) == null ? void 0 : M.label) || d.textValue || ""
            },
            d.id
          )
        );
      }
    }), b;
  }, y = (b, d, v) => {
    b.cellData.find((I) => I.id === d) && !v.includes(b) && v.push(b);
  }, N = () => {
    const b = [];
    return o.forEach((d) => {
      let v = !0;
      Object.entries(g.current).forEach(([I, s]) => {
        var M;
        if (s.length > 0) {
          const R = [];
          s.forEach((F) => {
            F.includes(",") ? F.split(",").forEach((z) => {
              R.push(z.trim());
            }) : R.push(F);
          });
          const U = e.findIndex((F) => {
            var z;
            return ((z = F.filterProp) == null ? void 0 : z.label) === I || F.textValue === I;
          }), O = ((M = d.cellData[U]) == null ? void 0 : M.id) || "", K = R.includes(O);
          K && (i.current[I].selectedLevel === -1 || i.current[I].selectedLevel > -1 && i.current[I] && i.current[I].selectedLevel !== i.current[I].selectedLevel) && (v = !1), !K && i.current[I].selectedLevel > -1 && (v = !1);
        }
      }), v && b.push(d);
    }), b;
  }, H = (b, d) => {
    b.preventDefault();
    const v = d.label, I = [];
    d.values.forEach((R) => {
      I.push(R);
    });
    const s = {
      ...g.current,
      [v]: I
    };
    Object.keys(s).every((R) => s[R].length === 0) ? g.current = {} : g.current = s;
    let M = [];
    n === "progressive" ? (T(v, d.values), M = N()) : Object.keys(s).forEach((R) => {
      const U = [...s[R]];
      o.forEach((O) => {
        U.forEach((K) => {
          K.includes(",") ? K.split(",").forEach((F) => y(O, F.trim(), M)) : y(O, K, M);
        });
      });
    }), M.length ? t(M) : (w(0), t(o));
  }, A = (b) => {
    b.preventDefault(), u && u(b), t(o), i.current = {}, g.current = {}, w(0);
  };
  return m && /* @__PURE__ */ Z(ot, { children: [
    /* @__PURE__ */ h(Ot, { children: C }),
    S(),
    /* @__PURE__ */ h(
      ct,
      {
        size: "small",
        variant: "text",
        onClick: A,
        children: $
      }
    )
  ] }) || /* @__PURE__ */ h(Ue, {});
}, jt = ({
  totalItems: e,
  tablePage: o,
  initialItemsPerPage: t,
  itemsPerPage: u,
  setItemsPerPage: C,
  setTablePage: $,
  showTotalItems: a = !0,
  showPerPageOption: n = !0,
  perPageLabel: l = "per page",
  itemsLabel: f = "of items",
  placeholder: g,
  ...m
}) => /* @__PURE__ */ h(
  lt,
  {
    totalItems: e,
    page: o,
    initialItemsPerPage: t,
    itemsPerPage: u,
    onItemsPerPageChange: C,
    showTotalItems: a,
    showPerPageOption: n,
    onPageChange: $,
    perPageLabel: l,
    itemsLabel: f,
    placeholder: g,
    ...m
  }
), { Clear: Ut, Search: Kt } = Ae, qt = Q.div`
  ${(e) => `
  width: ${e.theme.components.dataTable.TableSearchView.Container.width};
  max-width: ${e.theme.components.dataTable.TableSearchView.Container.maxWidth}
  `}
`, Gt = ({
  setRowValues: e,
  rowValues: o,
  searchValue: t,
  setSearchValue: u,
  searchPlaceholder: C,
  onSearch: $,
  onClear: a,
  setSearchEnabled: n,
  isStatic: l
}) => {
  const [f, g] = be(""), m = !!f.length, W = qe(() => !!f.length, [m]);
  te(() => {
    n(W);
  }, [W]), te(() => {
    t && (g(t), i(t));
  }, [o, t]);
  const i = mt((w) => {
    if (!(l && $))
      if (w === "")
        e(o);
      else {
        const D = o.filter((V) => V.cellData.some((T) => {
          var L, x, S, y, N;
          const E = ((L = T == null ? void 0 : T.textValue) == null ? void 0 : L.toLowerCase().includes(w.toLowerCase())) || ((x = T == null ? void 0 : T.cellAltText) == null ? void 0 : x.toLowerCase().includes(w.toLowerCase())) || typeof (T == null ? void 0 : T.description) == "string" && ((S = T == null ? void 0 : T.description) == null ? void 0 : S.toLowerCase().includes(w.toLowerCase()));
          if (!E && me((T == null ? void 0 : T.textValue) || "")) {
            const H = (N = (y = T == null ? void 0 : T.textValue) == null ? void 0 : y.toLowerCase()) == null ? void 0 : N.replaceAll(",", "");
            return H == null ? void 0 : H.includes(w.toLowerCase());
          }
          return E;
        }));
        e(D);
      }
  }, 300);
  return /* @__PURE__ */ h(qt, { children: /* @__PURE__ */ h(
    it,
    {
      startAdornmentProp: { startAdornment: /* @__PURE__ */ h(Kt, { size: "m" }) },
      endAdornmentProp: {
        endAdornment: /* @__PURE__ */ h(
          Ut,
          {
            size: "m",
            onClick: (w) => {
              g(""), i(""), u && u(""), a && a(w);
            }
          }
        )
      },
      placeholder: C || "Search here",
      textSize: "small",
      value: f,
      onChange: (w) => {
        g(w.target.value), i(w.target.value), u && u(w.target.value);
      },
      onKeyUp: (w) => {
        $ && $(w, f);
      }
    }
  ) });
}, Qt = Y.memo(Gt), Cn = ({
  headerValues: e = [],
  rowValues: o = [],
  paginationProp: t,
  isStickyColumnEnabled: u,
  isOptionProps: C,
  isCheckboxEnabled: $,
  disclosures: a,
  searchProp: n,
  filterProps: l,
  headerCheckboxProps: f,
  emptyTableMessage: g = "There is no data to display",
  isStatic: m = !1,
  sortingProps: W = { columnNumber: 0, order: "default" }
}) => {
  const i = Ge({ label: "Data Table" }), { width: w } = dt(), [D, V] = Y.useState(1), {
    setShowOptionsEnabled: T,
    setShowCheckboxEnabled: E,
    setIsStickyColumnEnabled: L,
    assignCheckboxesDefaultValues: x,
    setAllCheckboxChecked: S,
    sortOrder: y,
    setSortOrder: N,
    setRowIds: H
  } = Y.useContext(he), [A, b] = Y.useState([]), d = Y.useRef([]), v = Y.useRef(0), I = Y.useRef(!1), [s, M] = Y.useState(!1), [R, U] = Y.useState(!1), [O, K] = Y.useState(5);
  te(() => {
    v.current = (t == null ? void 0 : t.itemsPerPage) || 0;
  }, [t == null ? void 0 : t.itemsPerPage]);
  const F = (c) => c == null ? void 0 : c.map((r) => r == null ? void 0 : r.rowId);
  te(() => {
    const c = {
      columnNumber: W.columnNumber || y.columnNumber,
      value: W.order || y.value
    };
    N(c);
  }, []), te(() => {
    if (s || I.current) {
      const c = F(A);
      H && H(c);
    } else {
      const c = F(o);
      H && H(c);
    }
  }, [o, A, s, I.current]);
  const z = ({
    newTablePage: c,
    newUpdatedRowValues: r,
    sortOrderValue: B,
    comparator: q
  }) => {
    if (m) {
      d.current = r;
      const J = r;
      b(J.length === 0 ? [] : J);
    } else {
      let J = [];
      const G = B ?? y;
      if (R && (G == null ? void 0 : G.value) !== "default" && (J = r.slice().sort((k, ne) => {
        var ae, le, ie, de;
        const p = ((ae = k.cellData[G.columnNumber]) == null ? void 0 : ae.textValue) ?? ((le = k.cellData[G.columnNumber]) == null ? void 0 : le.cellAltText) ?? "", ee = ((ie = ne.cellData[G.columnNumber]) == null ? void 0 : ie.textValue) ?? ((de = ne.cellData[G.columnNumber]) == null ? void 0 : de.cellAltText) ?? "";
        return q ? q(p, ee, G.value === "desc") : G.value === "asc" ? !isNaN(Number(p)) && !isNaN(Number(ee)) ? Number(p) - Number(ee) : me(p) && me(ee) ? ue(p) - ue(ee) : p.localeCompare(ee) : !isNaN(Number(p)) && !isNaN(Number(ee)) ? Number(ee) - Number(p) : me(p) && me(ee) ? ue(ee) - ue(p) : ee.localeCompare(p);
      })), t && (t != null && t.isPaginationEnabled) && R && (G == null ? void 0 : G.value) !== "default") {
        d.current = J;
        const k = J.slice((c - 1) * v.current, c * v.current);
        b(k.length === 0 ? [] : k);
      } else if (R && (G == null ? void 0 : G.value) !== "default")
        b(J);
      else if (t && t.isPaginationEnabled) {
        d.current = r;
        const k = r.slice((c - 1) * v.current, c * v.current);
        b(k.length === 0 ? [] : k);
      } else
        b(r);
      c !== D && P(c);
    }
  };
  Y.useEffect(() => {
    var c, r;
    z({
      newUpdatedRowValues: !m && (s || I.current) && A || o,
      newTablePage: (s || I.current) && D || D,
      sortOrderValue: y,
      comparator: (r = (c = e[y.columnNumber]) == null ? void 0 : c.sortingProp) == null ? void 0 : r.comparator
    });
  }, [e, o, v, R]);
  const j = ({
    rowValues: c,
    sortOrderValue: r,
    filterOrSearchEnabled: B,
    comparator: q
  }) => {
    z({
      newUpdatedRowValues: c,
      newTablePage: B && 1 || D,
      sortOrderValue: r,
      comparator: q
    });
  };
  Y.useEffect(() => {
    t != null && t.tablePage && t.tablePage !== D && V(t == null ? void 0 : t.tablePage);
  }, [t == null ? void 0 : t.tablePage]), Y.useEffect(() => {
    T(!!(C != null && C.isOptionsEnabled));
  }, [C == null ? void 0 : C.isOptionsEnabled]), Y.useEffect(() => {
    L(!!u);
  }, [u]), Y.useEffect(() => {
    if (o.length) {
      const c = [];
      o.forEach((r) => {
        var q, J;
        const B = (f == null ? void 0 : f.checkboxDefaultValue) ?? r.checkboxDefaultValue ?? ((q = r.checkboxProps) == null ? void 0 : q.checkboxDefaultValue) ?? 0;
        c.push({
          id: r.rowId,
          value: B,
          disabled: ((J = r.checkboxProps) == null ? void 0 : J.disabled) || !1
        });
      }), x(c), f != null && f.checkboxDefaultValue && S(f == null ? void 0 : f.checkboxDefaultValue, c);
    }
  }, [o, f == null ? void 0 : f.checkboxDefaultValue]), Y.useEffect(() => {
    E(!!$);
  }, [$]);
  const _ = Y.useCallback(() => {
    K((t == null ? void 0 : t.totalItems) || d.current.length);
  }, [t == null ? void 0 : t.totalItems, d.current.length]);
  Y.useEffect(() => {
    _();
  }, [t == null ? void 0 : t.totalItems, d.current.length]);
  const P = (c) => {
    t != null && t.setTablePage && (t == null || t.setTablePage(c)), V(c);
  };
  return /* @__PURE__ */ Z(nt, { ...i, children: [
    (n == null ? void 0 : n.isSearchEnabled) && /* @__PURE__ */ h(
      Qt,
      {
        rowValues: s && A || o,
        setRowValues: (c) => {
          j({
            rowValues: c,
            filterOrSearchEnabled: !0
          });
        },
        setSearchEnabled: (c) => I.current = c,
        isStatic: m,
        ...n
      }
    ),
    (l == null ? void 0 : l.isFilterEnabled) && /* @__PURE__ */ h(
      zt,
      {
        variant: l.variant,
        sortFilterValues: l.sortFilterValues,
        headerValues: e,
        rowValues: I.current && A || o,
        setRowValues: (c) => {
          j({
            rowValues: c,
            filterOrSearchEnabled: !0
          });
        },
        onClearAll: l == null ? void 0 : l.onClearAll,
        filterGroupLabel: l == null ? void 0 : l.filterGroupLabel,
        setFilterEnabled: M,
        clearAllLabel: l == null ? void 0 : l.clearAllLabel,
        exceedOverflow: u
      }
    ),
    w >= Ze.tabletMin ? /* @__PURE__ */ Z(X, { isEmpty: !A.length, children: [
      /* @__PURE__ */ h(
        X.Head,
        {
          $checkboxProps: f,
          rowIds: s || I.current ? F(A) : F(o),
          children: e.map((c, r) => {
            var B, q;
            return /* @__PURE__ */ h(X.Header, { children: /* @__PURE__ */ Z(X.CellContent, { $contentAlignment: (c == null ? void 0 : c.contentAlignment) || "center", children: [
              c.leadingComponents,
              c.textValue && /* @__PURE__ */ h(X.CellContentText, { contentAlignment: (c == null ? void 0 : c.contentAlignment) || "center", children: c.textValue }),
              c.trailingComponents,
              (c.isSortingEnabled || ((B = c.sortingProp) == null ? void 0 : B.isSortingEnabled)) && /* @__PURE__ */ h(
                Je,
                {
                  rowValues: (I.current || s) && A || o,
                  setRowValues: (J, G) => {
                    var k;
                    j({
                      rowValues: J,
                      sortOrderValue: G,
                      comparator: (k = c.sortingProp) == null ? void 0 : k.comparator
                    });
                  },
                  columnName: c.textValue || c.columnAlternateText || "",
                  columnNumber: r,
                  onClick: (q = c.sortingProp) == null ? void 0 : q.onClick,
                  setSortingEnabled: U
                }
              )
            ] }) }, `${c.id}`);
          })
        }
      ),
      /* @__PURE__ */ Z(X.Body, { children: [
        A.map((c) => /* @__PURE__ */ h(
          X.Row,
          {
            id: c.rowId,
            $checkboxProps: c.checkboxProps,
            $dropDownComponent: c.DropDownComponent,
            children: c.cellData.map((r, B) => {
              var q, J, G, k;
              return /* @__PURE__ */ h(
                X.Cell,
                {
                  $contentAlignment: ((q = e[B]) == null ? void 0 : q.contentAlignment) || "center",
                  id: r.id,
                  children: /* @__PURE__ */ Z(X.CellWrapper, { $contentAlignment: ((J = e[B]) == null ? void 0 : J.contentAlignment) || "center", children: [
                    r.leadingComponents && /* @__PURE__ */ h(oe, { children: r.leadingComponents }),
                    (r.textValue || r.trailingComponents || r.description || (r == null ? void 0 : r.secondaryDescription)) && /* @__PURE__ */ Z(Ye, { children: [
                      /* @__PURE__ */ Z(X.CellContent, { $contentAlignment: ((G = e[B]) == null ? void 0 : G.contentAlignment) || "center", children: [
                        r.textValue && /* @__PURE__ */ h(X.CellContentText, { contentAlignment: ((k = e[B]) == null ? void 0 : k.contentAlignment) || "center", children: r.textValue }),
                        r.trailingComponents && !r.textValue && /* @__PURE__ */ h(oe, { children: r.trailingComponents })
                      ] }),
                      r.description && /* @__PURE__ */ h(X.CellDescription, { children: r.description }),
                      (r == null ? void 0 : r.secondaryDescription) && /* @__PURE__ */ h(X.CellDescription, { children: r == null ? void 0 : r.secondaryDescription })
                    ] }),
                    r.trailingComponents && r.textValue && /* @__PURE__ */ h(oe, { children: r.trailingComponents })
                  ] })
                },
                `${r.id || B}`
              );
            })
          },
          `${c.rowId}`
        )),
        A.length === 0 && /* @__PURE__ */ h(Xe, { isMobile: !1, children: g })
      ] })
    ] }) : /* @__PURE__ */ h(X.Container, { children: /* @__PURE__ */ h(
      Mt,
      {
        setSortingEnabled: U,
        emptyTableMessage: g,
        headerValues: e,
        rowValues: A,
        setRowValues: (c, r, B) => {
          j({
            rowValues: c,
            sortOrderValue: r,
            comparator: B
          });
        },
        headerCheckboxProps: f
      }
    ) }),
    a && /* @__PURE__ */ h(
      Pe,
      {
        disclosureContent: a == null ? void 0 : a.disclosureContent,
        id: a == null ? void 0 : a.id,
        className: a == null ? void 0 : a.className,
        disclosureTitleColor: a == null ? void 0 : a.disclosureTitleColor,
        style: a == null ? void 0 : a.style
      }
    ),
    (t == null ? void 0 : t.isPaginationEnabled) && /* @__PURE__ */ h(
      jt,
      {
        ...t,
        totalItems: O,
        tablePage: D,
        itemsPerPage: v.current,
        onItemsPerPageChange: (c) => {
          var r, B, q, J;
          t && (t != null && t.setItemsPerPage || t != null && t.onItemsPerPageChange) && ((r = t == null ? void 0 : t.setItemsPerPage) == null || r.call(t, c), (B = t == null ? void 0 : t.onItemsPerPageChange) == null || B.call(t, c)), v.current = c, z({
            newUpdatedRowValues: d.current,
            newTablePage: 1,
            sortOrderValue: y,
            comparator: (J = (q = e[y.columnNumber]) == null ? void 0 : q.sortingProp) == null ? void 0 : J.comparator
          });
        },
        setTablePage: (c) => {
          var r, B;
          z({
            newUpdatedRowValues: (I.current || s) && d.current || o,
            newTablePage: c,
            sortOrderValue: y,
            comparator: (B = (r = e[y.columnNumber]) == null ? void 0 : r.sortingProp) == null ? void 0 : B.comparator
          }), t && (t != null && t.setTablePage) && t.setTablePage(c);
        }
      }
    )
  ] });
};
export {
  ht as A,
  Cn as D,
  yt as a,
  Tn as b,
  mt as d
};
